import { Flex, Icon, Link, Spacing, Text } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { useSegment } from '../../../../../../../hooks'
import { popularArticles } from './constants/popularArticles'
import { PopularArticleItem } from './elements/PopularArticleItem'
import { getHelpCenterLink } from './utils/getHelpCenterLink'

export const PopularArticlesWidget = (): ReactElement => {
  const { t } = useTranslation()
  const { organization } = useUserOrganization()
  const { track } = useSegment()

  const helpCenterLink = getHelpCenterLink(t, organization?.countryId ?? 'DK')

  const popularArticlesForMarket = popularArticles[organization?.countryId ?? 'DK'] || popularArticles.DK

  const handleHelpCenterLinkClick = useCallback(() => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    track('xxx-help-modal-click-popular-topic', { article_link: helpCenterLink })
  }, [helpCenterLink, track])

  const handlePopularArticleClick = useCallback(
    (articleLink: string) => {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      track('xxx-help-modal-click-popular-topic', { article_link: articleLink })
    },
    [track],
  )

  return (
    <Flex flexDirection="column" gap={Spacing.S16}>
      <Flex alignItems="center" justifyContent="space-between">
        <Text>{t('help.modal.popular_articles.title')}</Text>
        <Link href={helpCenterLink} target="_blank" rel="noopener" onClick={handleHelpCenterLinkClick}>
          <Flex alignItems="center" justifyContent="space-between" gap={Spacing.S6}>
            {t('help.modal.help_center.label')}
            <Icon icon="squareArrowOutUpRight" size="xs" />
          </Flex>
        </Link>
      </Flex>
      {popularArticlesForMarket.map((item) => (
        <PopularArticleItem key={item.title} {...item} onClick={handlePopularArticleClick} />
      ))}
    </Flex>
  )
}
